'use client';
import { isString } from '@s7/utils';
import { AnalyticsPlugin } from '../../core/AnalyticsPlugin.js';
import { isScriptLoaded } from './initializer/status.js';
import { isScriptInjected } from '../../core/utils/isScriptInjected/isScriptInjected.js';
import { GTM_SOURCE } from './initializer/domain.js';
import { initializeGA } from './initializer/initializer.js';
import { defaultTransform } from './defaultTransform/defaultTransform.js';

var createPluginGA = function(options) {
    var initialize = options.initialize, _options_transform = options.transform, transform = _options_transform === void 0 ? defaultTransform : _options_transform;
    /**
     * Поле объекта window, содержащее очередь событий.
     * */ var dataLayerKey = "dataLayer";
    return AnalyticsPlugin({
        id: "analytics-plugin-ga",
        initialize: function initialize1() {
            if (initialize === false) {
                return isScriptLoaded;
            }
            if (isString(initialize)) {
                dataLayerKey = initialize;
                return isScriptLoaded;
            }
            if (initialize.key) {
                dataLayerKey = initialize.key;
            }
            if (isScriptInjected((initialize == null ? void 0 : initialize.scriptSource) || GTM_SOURCE)) {
                return isScriptLoaded;
            }
            initializeGA(initialize);
            return isScriptLoaded;
        },
        onEventEmitted: function onEventEmitted(eventName, payload) {
            if (dataLayerKey && window[dataLayerKey]) {
                var event = transform(eventName, payload);
                window[dataLayerKey].push(event);
                return event;
            }
        }
    });
};

export { createPluginGA };
